module.exports = "<div class=\"mobile-header\">\n    <ng-content></ng-content>\n</div>"